import { render, staticRenderFns } from "./InvitacionesPasoResumen.vue?vue&type=template&id=d8a2564c"
import script from "./InvitacionesPasoResumen.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitacionesPasoResumen.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports